export default "__VITE_ASSET__CzyDScw9__"